import { useState, useEffect } from 'react'
import { supabase } from '../../lib/supabase'

export default function StudentGrades() {
  const [grades, setGrades] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    async function fetch() {
      const { data: { user } } = await supabase.auth.getUser()
      const { data: acc } = await supabase.from('student_accounts').select('student_id').eq('id', user.id).single()
      if (!acc) { setLoading(false); return }
      const { data } = await supabase.from('grades').select('*').eq('student_id', acc.student_id).order('created_at', { ascending: false })
      setGrades(data || []); setLoading(false)
    }
    fetch()
  }, [])

  const pct = (s,t) => Math.round(s/t*100)
  const pctClass = (p) => p>=80?'badge-success':p>=60?'badge-warning':'badge-danger'

  if (loading) return <div className="empty">Loading...</div>

  const avg = grades.length ? Math.round(grades.reduce((a,g) => a+(g.score/g.total*100),0)/grades.length) : null

  return (
    <div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:20 }}>
        <h2 style={{ fontSize:20, fontWeight:500 }}>My Exams</h2>
        {avg !== null && (
          <span className={`badge ${pctClass(avg)}`} style={{ fontSize:14, padding:'5px 14px' }}>
            Avg: {avg}%
          </span>
        )}
      </div>
      {grades.length === 0 ? <div className="empty">No exams yet</div> : (
        <div className="card" style={{ padding:0, overflow:'hidden' }}>
          <table>
            <thead><tr><th>Exam</th><th>Date</th><th>Score</th><th>%</th><th>Note</th></tr></thead>
            <tbody>
              {grades.map(g => {
                const p = pct(g.score, g.total)
                return (
                  <tr key={g.id}>
                    <td style={{ fontWeight:500 }}>{g.exam_name}</td>
                    <td style={{ color:'var(--text3)' }}>{g.exam_date||'—'}</td>
                    <td>{g.score}/{g.total}</td>
                    <td><span className={`badge ${pctClass(p)}`}>{p}%</span></td>
                    <td style={{ color:'var(--text3)' }}>{g.note||'—'}</td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  )
}